import { styled, Typography } from '@mui/material';
import { H2 } from '../../legacy/style/styles';

export const BaseTypography = styled(Typography)(({ theme, color, fontWeight, fontStyle }) => ({
    fontFamily: theme.font.family,
    color: theme.color.black.main,
    fontStyle: 'normal',
    fontWeight: 'normal',
    ...(color && {
        color,
    }),
    ...(fontWeight && {
        fontWeight,
    }),
    ...(fontStyle && {
        fontStyle,
    }),
}));

export const SmallText = styled(BaseTypography)(({ theme }) => ({
    fontSize: theme.font.size.small,
}));
export const SmallTextItalic = styled(SmallText)(() => ({
    fontStyle: 'italic',
}));

export const RegularText = styled(BaseTypography)(({ theme }) => ({
    fontSize: theme.font.size.regular,
}));

export const MediumText = styled(BaseTypography)(({ theme }) => ({
    fontSize: theme.font.size.medium,
}));

export const PageTitle = styled(H2)`
    font-size: ${({ theme }) => theme.font.size.veryLarge};
    line-height: 1;
`;
